import styled from 'styled-components'

import Heading from '../../../../LuxKit/Typography/Heading'
import BodyText from '../../../../LuxKit/Typography/BodyText'

import { rem } from 'polished'
import ImageHero from '../../Common/ImageHero'

interface Props {
  title: string
  subheading: string
  imageId: string
}

const Container = styled(ImageHero)`
  max-height: ${rem(200)};
  display: flex;
  align-items: center;

  & > div:first-child {
    width: 100%;
  }
`

function DestinationProductPageHeader({ title, subheading, imageId }: Props) {
  if (imageId === '') {
    return null
  }
  return (
    <Container id={imageId} brightness={-30} mobileWidth="100vw" dpr={2}>
      <Heading variant="heading2" colour="dark-contrast" as="h1">{title}</Heading>
      <BodyText variant="large" colour="dark-contrast" as="h2" align="center">{subheading}</BodyText>
    </Container>
  )
}

export default DestinationProductPageHeader
